import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <rect width={24} height={24} fill={fill || "currentColor"} rx={4} />
    <path
      fill="#576473"
      fillRule="evenodd"
      d="M4 7.333c0-.368.298-.666.667-.666h14.666a.667.667 0 1 1 0 1.333H4.667A.667.667 0 0 1 4 7.333ZM4 12c0-.368.298-.667.667-.667h14.666a.667.667 0 0 1 0 1.334H4.667A.667.667 0 0 1 4 12Zm0 4.667c0-.368.298-.667.667-.667h14.666a.667.667 0 1 1 0 1.333H4.667A.667.667 0 0 1 4 16.667Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
